import { Sprite, Texture } from "pixi.js";

export class InputBlocker extends Sprite {
    public set blocked(value: boolean) {
        this.eventMode = value === true ? "dynamic" : "none";
    }

    public constructor() {
        super(Texture.WHITE);
        this.alpha = 0;
        this.blocked = true;
    }
}